import { render, staticRenderFns } from "./zTable.vue?vue&type=template&id=206f0813&scoped=true&"
import script from "./zTable.vue?vue&type=script&lang=ts&"
export * from "./zTable.vue?vue&type=script&lang=ts&"
import style0 from "./zTable.vue?vue&type=style&index=0&id=206f0813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f0813",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
